import { TableTemplate } from "components/templates/default/table/TableTemplate";
import AddModal from "./add";
import { AccountInfo } from "api/interfaces/accountInterface.interface";
import { ClickSearch } from "components/atoms/input/search/SearchInput";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import Status, { StatusType } from "components/blocks/status/Status";
import { TableColumnsType } from "antd";
import {
  CommonTable,
  ExpandTableContainer,
} from "components/atoms/table/AntdTable";
import AccountDetailContainer from "./detail";
import { ExpandableConfig } from "antd/es/table/interface";

type Props = {
  isAddModal: boolean;
  isEditModal: null | AccountInfo;
  onModal: (type?: string) => void;
  columns: TableColumnsType<AccountInfo>;
  data: Array<AccountInfo>;
  onClickSearch: ClickSearch;
  paginationPerPage: number | undefined;
  queryInfo: BasePagination;
  keyword: string;
  onChangePage: (page: number, totalRows: number) => void;
  status: StatusType;
  initialPending: boolean;
  onSuccessCreateAccount: () => void;
  expandableProps?: ExpandableConfig<AccountInfo>;
  AccountAccessModal: JSX.Element | null;
};

export function AccountPresenter({
  isAddModal,
  isEditModal,
  onModal,
  columns,
  data,
  onClickSearch,
  queryInfo,
  keyword,
  onChangePage,
  status,
  initialPending,
  onSuccessCreateAccount,
  expandableProps,
  AccountAccessModal,
}: Props): JSX.Element {
  return (
    <>
      <TableTemplate
        titleComponent={"Organization List"}
        onClickBtn={() => onModal("add")}
        buttonLabel={"Add Organization"}
        keyword={keyword}
        onClickSearch={onClickSearch}
        centerChildren={<Status status={status} />}
        requiredPermissions={"manageAccount"}
        data-testid="account-account-presenter-tsx-account-table-template-modal"
      >
        <ExpandTableContainer>
          <CommonTable
            columns={columns}
            dataSource={data}
            queryInfo={queryInfo}
            onChangePage={onChangePage}
            loading={initialPending}
            expandable={expandableProps}
            rowKey="accountId"
          />
        </ExpandTableContainer>
      </TableTemplate>
      {isAddModal && (
        <AddModal
          onModal={() => onModal("add")}
          onSuccessCreateAccount={onSuccessCreateAccount}
        />
      )}

      {isEditModal !== null && (
        <AccountDetailContainer
          onModal={() => onModal("edit")}
          onSuccessEditAccount={onSuccessCreateAccount}
          accountId={isEditModal.accountId}
          enableTransfer={isEditModal.enableTransfer}
        />
      )}

      {AccountAccessModal}
    </>
  );
}
